import { GenderValue, RaceValue, UserRole } from 'types/enums';
import { SignUpFormDto, UserRoleType } from 'types/types';
import { getUserRoleTitle } from 'utils';

const getDefaultValues = (role: UserRoleType): SignUpFormDto => ({
  firstName: '',
  lastName: '',
  username: '',
  email: '',
  study: '',
  medicalRecordNumber: '',
  dateOfBirth: '',
  conditions: [],
  gender: 'Male',
  race: '',
  role,
});

const ROLE_RADIO_VALUES = Object.values(UserRole).reduce((acc, id) => {
  if (id !== UserRole.ADMIN) {
    acc.push({
      label: getUserRoleTitle(id),
      id,
    });
  }

  return acc;
}, [] as { label: string; id: typeof UserRole[keyof typeof UserRole] }[]);

const GENDER_RADIO_VALUES = Object.values(GenderValue).map((value) => ({ label: value, id: value }));

const HUMAN_RACES = Object.values(RaceValue).map((value) => ({ label: value, id: value }));

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export { getDefaultValues, EMAIL_PATTERN, ROLE_RADIO_VALUES, GENDER_RADIO_VALUES, HUMAN_RACES };
